/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

          $(document).ready(function(){
              $(".sidebar-menu-resources .dropdown .icon").next('.dropdown-menu').addClass("collapsed").slideUp();

              $(".sidebar-menu-resources ").on('click', '.icon', function () {
                  var currentClass = $(this).next('.dropdown-menu').prop('class');
                  if (currentClass == "dropdown-menu expanded") {
                      $(this).next().removeClass("expanded");
                      $(this).next().addClass("collapsed");
                      $(this).next().slideUp();
                  } else {
                      $(".expanded").slideUp().addClass("collapsed").removeClass("expanded");

                      $(this).next().removeClass("collapsed");
                      $(this).next().addClass("expanded");
                      $(this).next().slideDown();
                  }

              });
          });

          $( ".navbar-main .navbar-nav li" ).mouseenter(function () {
              $(this).prev().addClass('before');
              $(".navbar-main .navbar-nav li").removeClass('active');
          });

          $( ".navbar-main .navbar-nav li" ).mouseleave(function () {
              $(this).prev().removeClass('before');
              $(".navbar-main .navbar-nav li.current-menu-item").addClass('active');
          });


          $(document).ready(function(){
              $('.owl-carousel').owlCarousel({
                  autoplay:true,
                  autoplaySpeed: 1500,
                  autoplayTimeout: 4000,
                  margin:10,
                  loop: true,
                  items:1
              });
          });

          $(document).ready(function(){
              $(".section-our-services .row >div >div").mouseenter(function(){
                  $(this).find('.animate-me').addClass("hvr-float-shadow");
              });

              $(".section-our-services .row >div >div").mouseleave(function(){
                  $(this).find('.animate-me').removeClass("hvr-float-shadow");
              });
          });

          $(document).ready(function(){
              $(".section-connect-with-us").each(function () {
                  $(this).prev().css('padding-bottom',function (index,curValue) {
                      return parseInt(curValue, 10) + 47 + 'px';
                  });
              });
          });

          (function($){

              $('.navbar-nav-menu>li>a>.icon-cheveron-down').click(function (e) {
                  e.preventDefault();
                  $('.navbar-nav-menu>li>a').find('.dropdown-menu').not($(this).parent('a').parent('li').find('.dropdown-menu')).slideUp(100);
                  $(this).parent('a').next('.dropdown-menu').slideToggle(100);
              });

              $('.navbar-nav-menu>li>.dropdown-menu>li>a>.icon-cheveron-down').click(function (e) {
                  e.preventDefault();
                  $('.navbar-nav-menu li .dropdown-menu li').find('.dropdown-menu').not($(this).parent('.dropdown-menu li a').parent('.dropdown-menu li').find('.dropdown-menu')).slideUp(100);
                  $(this).parent('.dropdown-menu li a').parent('.dropdown-menu>li').find('.dropdown-menu').slideToggle(100);
              });
          })(jQuery);

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
